export const API_BASE =
    process.env.NODE_ENV === "production"
        ? process.env.REACT_APP_API
        : "http://localhost:4003";


export const EMP_PROFILE_FILE_BASE =
    process.env.NODE_ENV === "production"
        ? process.env.REACT_APP_EMP_PROFILE_FILE
        : "http://localhost:4002";

// dAdmin owns the global sign-in config (banners, rotation, two-step). Read-only,
// unauthenticated, read cross-origin from every dApp's sign-in screen.
export const DADMIN_API_BASE =
    process.env.NODE_ENV === "production"
        ? process.env.REACT_APP_DADMIN_API
        : "http://localhost:4002";

// An admin revoking someone in dAdmin now ends their session. The server
// answers 401 SESSION_REVOKED on the next request; without this the page would
// render broken data and leave the person apparently signed in.
//
// Handled here rather than per page so it cannot be forgotten by one caller.
// Guarded so a burst of parallel requests cannot cause a redirect loop, and
// skipped on the sign-in routes, where a 401 is an ordinary answer.
let sessionEnded = false;

export async function apiFetch(endpoint, options = {}) {
    const res = await fetch(`${API_BASE}${endpoint}`, {
        credentials: "include",
        ...options,
    });

    if (res.status === 401 && !sessionEnded && !endpoint.startsWith("/api/login/")) {
        let message = "";
        // Read from a clone so the caller still gets an unconsumed body.
        try { message = (await res.clone().json())?.message || ""; } catch { /* not JSON */ }
        // Checked again here, not only above: a burst of parallel requests all
        // pass that first check before any of them has finished reading its body.
        if (message === "SESSION_REVOKED" && !sessionEnded) {
            sessionEnded = true;
            window.location.replace("/Login?revoked=1");
        }
    }

    return res;
}
